import React from 'react'

import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import { Button, Form, Col, Row, Divider, Tabs } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { CodigosTransaccionesConstant } from 'constants/index'

import TipoImpresionConstant from 'constants/tiposImpresion'

import * as UsuarioCrud from 'services/usuario.service'

import { RetrocederButton } from 'sharedComponents/buttons'

import * as FormGroups from './formGroups'
import * as InnerTabs from './tabs'

const validationSchema = Yup.object().shape({
  _idIsla: Yup.string().notRequired(),
  username: Yup.string().required(),
  contrasena: Yup.string().required(),
  flagAtencionIsla: Yup.bool().required(),
  flagAkdemic: Yup.bool().required(),
  flagFacturacionConIGV: Yup.bool().required(),
  flagVentaCobranzaAdministrativa: Yup.bool().required(),
  flagEditarVentas: Yup.bool().required(),
  flagCambioAno: Yup.bool().required(),
  flagCambioFecha: Yup.bool().required(),
  flagTurno: Yup.bool().required(),
  flagModificarPrecioVenta: Yup.bool().required(),
  flagPuntoVenta: Yup.bool().required(),
  companias: Yup.array().required(),
  sedes: Yup.array().required()
  // correo: Yup.string().matches(/^[a-zA-Z0-9._-]+@gmail\.com$/, 'Por favor, introduce un correo de Gmail válido')
})

const validationSchemaEdicion = Yup.object().shape({
  _idIsla: Yup.string().notRequired(),
  username: Yup.string().required(),
  flagAtencionIsla: Yup.bool().required(),
  flagAkdemic: Yup.bool().required(),
  flagFacturacionConIGV: Yup.bool().required(),
  flagEditarVentas: Yup.bool().required(),
  flagCambioAno: Yup.bool().required(),
  flagVentaCobranzaAdministrativa: Yup.bool().required(),
  flagCambioFecha: Yup.bool().required(),
  flagTurno: Yup.bool().required(),
  flagModificarPrecioVenta: Yup.bool().required(),
  flagPuntoVenta: Yup.bool().required(),
  companias: Yup.array().required(),
  sedes: Yup.array().required()
})

const NuevoMainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const history = useHistory()

  const submitHandler = React.useCallback(
    async data => {
      const funcionCrud = editarData._id
        ? () => UsuarioCrud.actualizarxId(editarData._id, data)
        : () => UsuarioCrud.nuevo(data)
      await funcionCrud()
        .then(() => {
          history.push(`/${CodigosTransaccionesConstant.USUARIOS_LISTA}`)
          __zariContext.snack('success', editarData._id ? 'El registro se ha actualizado' : 'El registro se ha creado.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, history, editarData._id]
  )

  const formInitialValues = React.useMemo(() => {
    if (editarData._id) {
      return {
        _idIsla: editarData._idIsla || '',
        _idsSeries: editarData._idsSeries || [],
        _idsRoles: editarData._idsRoles || [],
        apellidos: editarData.apellidos || '',
        companias: editarData.companias || [],
        flagAtencionIsla: editarData.flagAtencionIsla || false,
        flagAkdemic: editarData.flagAkdemic || false,
        flagVisible: editarData.flagVisible || false,
        flagCambioCuenta12: editarData.flagCambioCuenta12 || false,
        flagCambioFecha: editarData.flagCambioFecha || false,
        flagFacturacionConIGV: editarData.flagFacturacionConIGV || false,
        flagEditarVentas: editarData.flagEditarVentas || false,
        flagCambioAno: editarData.flagCambioAno || false,
        flagVentaCobranzaAdministrativa: editarData.flagVentaCobranzaAdministrativa || false,
        flagValidarTokenEscritorio: editarData.flagValidarTokenEscritorio || false,
        flagTurno: editarData.flagTurno || false,
        flagModificarPrecioVenta: editarData.flagModificarPrecioVenta || false,
        flagPuntoVenta: editarData.flagPuntoVenta || false,
        flagLogistica: editarData.flagLogistica || false,
        flagGerencia: editarData.flagGerencia || false,
        tipoImpresion: editarData.tipoImpresion || TipoImpresionConstant.A4,
        nombres: editarData.nombres || '',
        sedes: editarData.sedes || [],
        username: editarData.username || '',
        correo: editarData.correo || '',
        oficinas: editarData.oficinas || []
      }
    }

    return {
      _idIsla: '',
      _idsRoles: [],
      _idsSeries: [],
      username: '',
      correo: '',
      nombres: '',
      apellidos: '',
      contrasena: '',
      flagAtencionIsla: false,
      flagVisible: false,
      flagAkdemic: false,
      flagCambioCuenta12: false,
      flagFacturacionConIGV: false,
      flagCambioFecha: false,
      flagEditarVentas: false,
      flagCambioAno: false,
      flagValidarTokenEscritorio: false,
      flagVentaCobranzaAdministrativa: false,
      flagTurno: false,
      flagModificarPrecioVenta: false,
      flagPuntoVenta: false,
      flagLogistica: false,
      flagGerencia: false,
      tipoImpresion: TipoImpresionConstant.A4,
      companias: [],
      sedes: [],
      firmas: [],
      oficinas: []
    }
  }, [editarData])

  return (
    <Row>
      <Col md={12}>
        <Formik
          initialValues={formInitialValues}
          onSubmit={submitHandler}
          validationSchema={editarData._id ? validationSchemaEdicion : validationSchema}
        >
          {({ errors, handleSubmit, isSubmitting, touched, values }) => (
            <Form>
              <Divider title='Datos Básicos' />
              <Row>
                <Col md={6}>
                  <FormGroups.UsernameFormGroup
                    iError={errors.username}
                    iTouched={touched.username}
                    fIsSubmitting={isSubmitting}
                  />
                  {!editarData._id && (
                    <FormGroups.ContrasenaFormGroup
                      iError={errors.contrasena}
                      iTouched={touched.contrasena}
                      fIsSubmitting={isSubmitting}
                    />
                  )}
                </Col>
                <Col md={6}>
                  <FormGroups.NombresFormGroup />
                  <FormGroups.ApellidosFormGroup />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.CorreoFormGroup />
                </Col>
              </Row>
              <Divider title='Personalización' />
              <Tabs defaultActiveKey='1' id='personalizacion-usuarios-tab'>
                <Tabs.Tab eventKey='1' title='Accesos y Series'>
                  <InnerTabs.AccesosSeriesTab
                    companiasSeleccionadas={values.companias}
                    sedesSeleccionadas={values.sedes}
                    seriesSeleccionadas={values._idsSeries}
                  />
                </Tabs.Tab>
                <Tabs.Tab eventKey='2' title='Roles'>
                  <InnerTabs.RolesTab rolesSeleccionados={values._idsRoles} />
                </Tabs.Tab>
                {__adminContext.valoresConfiguracionCompania.flagGrifo && (
                  <Tabs.Tab eventKey='3' title='A. Grifo'>
                    <InnerTabs.AtencionGrifoTab
                      isSubmitting={isSubmitting}
                      values={values}
                      errors={errors}
                      touched={touched}
                    />
                  </Tabs.Tab>
                )}
                <Tabs.Tab eventKey='4' title='Parámetros'>
                  <InnerTabs.ParametrosTab isSubmitting={isSubmitting} values={values} />
                </Tabs.Tab>
                <Tabs.Tab eventKey='5' title='Oficinas'>
                  <InnerTabs.OficinasTab isSubmitting={isSubmitting} oficinasSeleccionados={values.oficinas} />
                </Tabs.Tab>
              </Tabs>
              <Row className='mt-4'>
                <Col md={12} className='text-right'>
                  <RetrocederButton />
                  <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  )
}

export default NuevoMainForm
